import { render, staticRenderFns } from "./senderReceiverAction.vue?vue&type=template&id=ae149102&"
import script from "./senderReceiverAction.vue?vue&type=script&lang=js&"
export * from "./senderReceiverAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports